import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './AthleteUserContactsDetailValidation'

import NavLinks from '../../../meet/NavLinks';
import EntryNavLinks from '../../EntryNavLinks';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOrgUnitAthleteEntryInfoData from '../../../../state/orgUnitAthleteEntryInfo/UseOrgUnitAthleteEntryInfoData';
import useOrgUnitAthleteContactData from '../../../../state/orgUnitAthleteContact/UseOrgUnitAthleteContactData';

import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import UseForm from "@usas/ui-web/utils/UseForm";

const useAthleteUserContactsDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { omeMeetState } = useOmeMeetData();
  const { orgUnitAthleteEntryInfoState } = useOrgUnitAthleteEntryInfoData();
  const { orgUnitAthleteContactState, postOrgUnitAthleteContact, putOrgUnitAthleteContact, confirmSaveOrgUnitAthleteContact } = useOrgUnitAthleteContactData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const { formState, errorState, setFormData, setErrors, onFormValueChanged, handleSubmit, isDirty } = UseForm(getInitialFormState(), submitFormCallback, validate);
  const [state, setState] = useState({ tryGetOmeMeet: false, tryRedirect: false });

  const tryValidateBeforeRedirect = async () => {
    const errors = await validate(formState) || {};
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      setState({ ...state, tryRedirect: true });
    }
  };

  const onNextButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    if (isDirty === false) {
      tryValidateBeforeRedirect();
    }
    else {
      handleSubmit();
    }
  };

  const onBackButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    if (omeMeetState.route !== '') {
      navigate(NavLinks.ATHLETE_CONTACTS);
    }
    else {
      navigate(EntryNavLinks.ATHLETE_CONTACTS);
    }
  };

  useEffect(() => {
    if (location.state) {
      setFormData({
        ...formState,
        orgUnitAthleteContactId: location.state?.orgUnitAthleteContactId || '',
        personId: location.state?.personId || '',
        memberId: location.state?.memberId || '',
        emailAddress: location.state?.emailAddress || ''
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const isContactDetailSaved = contactsDetailFormStateHasBeenSaved(formState);
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: isContactDetailSaved });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.meetInfoFormState, formState, orgUnitAthleteContactState]);

  useEffect(() => {
    if (state.tryConfirmSave === true && orgUnitAthleteContactState.isSaving === false &&
      orgUnitAthleteContactState.isSaved === true) {
      confirmSaveOrgUnitAthleteContact();
      setState({ ...state, tryConfirmSave: false, tryRedirect: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryConfirmSave, orgUnitAthleteContactState])

  useEffect(() => {
    if (state.tryRedirect === true && orgUnitAthleteEntryInfoState.isObjLoading === false &&
      orgUnitAthleteEntryInfoState.isObjLoaded === true) {
      if (omeMeetState.route === '') {
        //OME Route
        navigate(EntryNavLinks.ATHLETE_CONTACTS, { state: { tryGetContacts: true } });
      }
      else {
        //Meet Route
        navigate(NavLinks.ATHLETE_CONTACTS, { state: { tryGetContacts: true } });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryRedirect, orgUnitAthleteEntryInfoState])

  function contactsDetailFormStateHasBeenSaved(formState) {
    //compare contacts detail formState to orgUnitAthleteContactState to see if formState has been saved
    //Edit contact
    if (formState?.orgUnitAthleteContactId !== '') {
      const selectedOmeMeetOrgUnitContact = orgUnitAthleteContactState.arrayData?.find(x =>
        x.orgUnitAthleteContactId === formState?.orgUnitAthleteContactId);
      if (formState?.memberId !== selectedOmeMeetOrgUnitContact?.memberId
        && (formState?.memberId !== '' || selectedOmeMeetOrgUnitContact?.memberId !== null)) {
        return false;
      }
      if (formState?.emailAddress !== selectedOmeMeetOrgUnitContact?.emailAddress
        && (formState?.emailAddress !== '' || selectedOmeMeetOrgUnitContact?.emailAddress !== null)) {
        return false;
      }
    }
    //Add contact
    else {
      if (isDirty === true) {
        return false;
      }
      return true;
    }

    return true;
  }

  function submitFormCallback(formState) {
    //Save Contact
    if (formState.orgUnitAthleteContactId) {
      const orgUnitAthleteContactObj = {
        orgUnitAthleteContactId: formState.orgUnitAthleteContactId,
        athletePersonId: orgUnitAthleteEntryInfoState.objData.personId,
        omeMeetId: orgUnitAthleteEntryInfoState.objData.omeMeetId,
        personId: formState.personId,
        emailAddress: formState.emailAddress.trim(),
      };
      putOrgUnitAthleteContact(formState.orgUnitAthleteContactId, orgUnitAthleteContactObj);
    }
    else {
      const orgUnitAthleteContactObj = {
        athletePersonId: orgUnitAthleteEntryInfoState.objData.personId,
        omeMeetId: orgUnitAthleteEntryInfoState.objData.omeMeetId,
        personId: formState.personId,
        emailAddress: formState.emailAddress.trim(),
      };

      postOrgUnitAthleteContact(orgUnitAthleteContactObj);
    }
    setState({ ...state, tryConfirmSave: true });
  }

  function getInitialFormState() {
    return ({
      orgUnitAthleteContactId: '',
      personId: '',
      memberId: '',
      emailAddress: ''
    })
  }

  return {
    orgUnitAthleteEntryInfoState,
    orgUnitAthleteContactState,
    formState,
    errorState,
    handleSubmit,
    setFormData,
    onFormValueChanged,
    onNextButtonClicked,
    onBackButtonClicked
  };
};

export default useAthleteUserContactsDetail;